import Module from "./Module.vue";
import WelcomePage from "./views/WelcomePage.vue";
import TermsPage from "./views/TermsPage.vue";
import SuccessPage from "./views/SuccessPage.vue";
import DashboardPage from "./views/DashboardPage.vue";
import MutasiSaldoPage from "./views/MutasiSaldoPage.vue";
import RekeningSetPage from "./views/RekeningSetPage.vue";
import RiwayatTarikTunai from "./views/RiwayatTarikTunai.vue";
import AfiliatedPage from "./views/AfiliatedPage.vue";
import WithdrawPage from "./views/WithdrawPage.vue";
import VerifikasiOTP from "./views/VeirifikasiOTP.vue"

const requireAuth = { requireAuth: true };

const moduleRoute = {
  path: "/afiliasi",
  component: Module,
  children: [
    {
      path: "",
      name: "afiliasi.welcome_page",
      component: WelcomePage,
      meta: requireAuth,
    },
    {
      path: "terms",
      name: "afiliasi.terms",
      component: TermsPage,
      meta: requireAuth,
    },
    {
      path: "register-success",
      name: "afiliasi.sucsess",
      component: SuccessPage,
    },
    {
      path: "dashboard",
      component: Module,
      children: [
        {
          path: "",
          name: "afiliasi.dashboard",
          component: DashboardPage,
          meta: requireAuth,
        },
        {
          path: "withdraw",
          name: "afiliasi.dashboard.withdraw",
          component: WithdrawPage,
          meta: requireAuth,
        },
        {
          path: "make-withdraw",
          name: "afiliasi.dashboard.make_withdraw",
          components: {
            default: WithdrawPage,
            dialog: () => import("./components/SOModalWithdraw.vue"),
          },
          meta: requireAuth,
        },
      ],
    },
    {
      path: "terms-and-conditions",
      name: "afiliasi.terms_conditions",
      component: TermsPage,
      meta: requireAuth,
    },
    {
      path: "mutasi-saldo",
      name: "afiliasi.mutasi_saldo",
      component: MutasiSaldoPage,
      meta: requireAuth,
    },
    {
      path: "rekening-tarik-tunai",
      name: "afiliasi.set_rekening",
      component: RekeningSetPage,
      meta: requireAuth,
    },
    {
      path: "riwayat-tarik-tunai",
      name: "afiliasi.cash_history",
      component: RiwayatTarikTunai,
      meta: requireAuth,
    },
    {
      path: "teman-yang-bergabung",
      name: "afiliasi.afiliated",
      component: AfiliatedPage,
      meta: requireAuth,
    },
    {
      path: "verifikasi-otp",
      name: "afiliasi.verif_otp",
      component: VerifikasiOTP,
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
